
import React from "react";
import { useAuth } from "@/context/AuthContext";
import AffiliatePanel from "@/components/affiliate/AffiliatePanel";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign } from "lucide-react";
import ActiveTrialBanner from "@/components/ActiveTrialBanner";

const AffiliatePage = () => {
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="bg-gradient-to-r from-green-500 to-emerald-500 p-3 rounded-xl shadow-lg">
                  <DollarSign className="w-8 h-8 text-white" />
                </div>
                <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
                  Sistema de Afiliados
                </h1>
              </div>
               <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                  Ganhe dinheiro compartilhando nossa plataforma! Receba 20% de comissão em cada venda realizada através do seu link.
                 </p>
            </div>
            
            {/* Active Trial Banner */}
            <ActiveTrialBanner />

            {/* Informações do programa */}
            <Card className="mb-8">
              <CardHeader>
                <CardTitle>Como funciona o programa de afiliados?</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="text-center">
                    <div className="bg-blue-100 dark:bg-blue-900/20 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                      <span className="text-blue-600 dark:text-blue-400 font-bold text-xl">1</span>
                    </div>
                    <h3 className="font-semibold mb-2">Crie seu código</h3>
                    <p className="text-sm text-muted-foreground">
                      Gere seu código único de afiliado gratuitamente
                    </p>
                  </div>
                  
                  <div className="text-center">
                    <div className="bg-green-100 dark:bg-green-900/20 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                      <span className="text-green-600 dark:text-green-400 font-bold text-xl">2</span>
                    </div>
                    <h3 className="font-semibold mb-2">Compartilhe</h3>
                    <p className="text-sm text-muted-foreground">
                      Divulgue seu link nas redes sociais, blogs ou grupos
                    </p>
                  </div>
                  
                  <div className="text-center">
                    <div className="bg-yellow-100 dark:bg-yellow-900/20 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                      <span className="text-yellow-600 dark:text-yellow-400 font-bold text-xl">3</span>
                    </div>
                     <h3 className="font-semibold mb-2">Ganhe 20%</h3>
                     <p className="text-sm text-muted-foreground">
                       Receba comissão em cada venda realizada
                     </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Painel de afiliados */}
            <AffiliatePanel />
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default AffiliatePage;
